import { Link } from 'expo-router';

import { ThemedText } from '@/components/themed-text';
import { ThemedView } from '@/components/themed-view';

export default function SignupScreen() {
  return (
    <ThemedView className="flex-1 items-center justify-center px-8">
      <ThemedText type="title" className="mb-2 text-5xl text-gold-dark dark:text-gold">
        Pentarchy
      </ThemedText>
      <ThemedText type="muted" className="mb-12">
        A book club for the ages
      </ThemedText>

      <ThemedText type="subtitle" className="mb-8">
        Create Account
      </ThemedText>

      <Link href="/login">
        <ThemedText type="link">{'\u2190'} Back to login</ThemedText>
      </Link>
    </ThemedView>
  );
}
